const domReadyChecker = (domIsReady) => {
  const isBrowserIeOrNot = () => {
    return (!document.attachEvent || typeof document.attachEvent === 'undefined' ? 'not-ie' : 'ie');
  };

  domIsReady = (callback) => {
    if(callback && typeof callback === 'function'){
      if(isBrowserIeOrNot() !== 'ie') {
        document.addEventListener('DOMContentLoaded', () => {
          return callback();
        });
      } else {
        document.attachEvent('onreadystatechange', () => {
          if(document.readyState === 'complete') {
            return callback();
          }
        });
      }
    }
  };

  return domIsReady;
};

const domIsReady = domReadyChecker();
domReadyChecker(domIsReady);

const ready = (document, window, domIsReady) => {
  domIsReady(() => {
    
  });
};

ready(document, window, domIsReady);
